'use client'

import { cn } from '@/lib/utils'

export interface EditorToolbarDividerProps {
  className?: string
}

export const EditorToolbarDivider = ({ className }: EditorToolbarDividerProps) => (
  <hr aria-orientation="vertical" className={cn('mx-1 h-6 w-px border-0 bg-border', className)} />
)

EditorToolbarDivider.displayName = 'EditorToolbarDivider'
